// extracted by mini-css-extract-plugin
export default {"modalContainer":"LeaveServiceModal1_modalContainer__krP0I","slideUp":"LeaveServiceModal1_slideUp__LUCYJ"};